import React from 'react'
import Link from 'gatsby-link'

const Header = () => (
    <div
        style={{
            zIndex:1,
            left:0,
            right:0,
            position: 'fixed',
            background: 'rgba(0,0,0,.0)',
        }}
    >
        <div
            style={{
                margin: '0 auto',
                maxWidth: 960,
                padding: '1.45rem 1.0875rem',
            }}
        >
            <h1 style={{margin: 0}}>
                <Link
                    className="brand"
                    to="/"
                    style={{
                        padding: '0 14px',
                        color: 'white',
                        backgroundColor: 'rgb(0, 255, 0)',
                        textDecoration: 'none',
                        fontFamily: "'Permanent Marker', cursive",
                    }}
                >
                    Fishfin
                </Link>
                <Link
                    className="nav-link"
                    to="/links"
                    style={{
                        fontSize: 18,
                        marginTop: 8,
                        marginRight: 15,
                        color: 'white',
                        textDecoration: 'none',
                        float: 'right',
                        borderBottom: '1px solid white',
                        padding: '3px',
                        background: 'rgba(0,0,0,.3)',
                        transition: '.2s all'
                    }}
                >
                    Links
                </Link>
                <Link
                    className="nav-link"
                    to="/gallery"
                    style={{
                        fontSize: 18,
                        marginTop: 8,
                        marginRight: 15,
                        color: 'white',
                        textDecoration: 'none',
                        float: 'right',
                        borderBottom: '1px solid white',
                        padding: '3px',
                        background: 'rgba(0,0,0,.3)',
                        transition: '.2s all'
                    }}
                >
                    Gallery
                </Link>
            </h1>
        </div>
    </div>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/index.js